import 'bootstrap';
import '../css/_root.scss';
import './barba/load-page-modules';
import { MobileMenu } from './widgets/mobile-menu';
import { initContactUsDrawer } from './widgets/contact-us-draver';
import { HideCarouselButtonsWidget } from './widgets/hide-carousel-buttons-widget';
import { initHeaderDesktopScrollDark } from './widgets/header-desktop-scroll-dark';
import { initHeaderNavActiveState } from './widgets/header-nav-active';
import { initLoginModalTriggers } from './widgets/login-modal';
import { initContactUsDrawerTriggers } from './widgets/contact-us-draver';
import { initBookingTriggers } from './widgets/booking-of-infrastructure';
import { initApplicationForResidencyTriggers } from './widgets/application-for-residency';
import { initNewPasswordModalFromUrl } from './widgets/login-modal/new-password-modal';
import { UserMenuWidget } from './widgets/user-menu-widget';
import { initBarba, syncBodyClusterZoneFromPage } from './barba/init-barba';
import { getNamespaceFromDom, runPageInit } from './barba/page-init-registry';
import { applySubnavForNamespace } from './widgets/page-subnav/apply-subnav-for-namespace';
import { initTeamMemberCards } from './widgets/team-member-cards';
import {
  initYandexMetrikaLkLinkTracking,
  initYandexMetrikaVideoTracking,
} from './utils/yandex-metrika';
import { initEducationPageTabsNav } from './utils/education-page-tabs';

function initGlobalComponents(): void {
  // Инициализация меню хэдера
  new MobileMenu();
  new HideCarouselButtonsWidget().init();
  initHeaderDesktopScrollDark();
  initHeaderNavActiveState();
  window.addEventListener('stc:barba-after-enter', initHeaderNavActiveState);
  initLoginModalTriggers();
  initContactUsDrawerTriggers();
  initBookingTriggers();
  initApplicationForResidencyTriggers();
  initNewPasswordModalFromUrl();
  new UserMenuWidget().init();
  initContactUsDrawer();
  initYandexMetrikaVideoTracking();
  initYandexMetrikaLkLinkTracking();
  initEducationPageTabsNav();
}

function bootstrap(): void {
  const currentBarbaContainer =
    document.querySelector<HTMLElement>('[data-barba="container"]') ?? document;
  const namespace = getNamespaceFromDom(
    currentBarbaContainer instanceof HTMLElement ? currentBarbaContainer : undefined,
  );

  initGlobalComponents();
  initTeamMemberCards();
  syncBodyClusterZoneFromPage();
  runPageInit(namespace, currentBarbaContainer);
  applySubnavForNamespace(namespace);
  initBarba();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}

declare global {
  interface Grecaptcha {
    ready(cb: () => void): void;
    execute(siteKey: string, options: { action: string }): Promise<string>;
  }

  interface Window {
    grecaptcha?: Grecaptcha;
  }
}

export {};
